// extracted by mini-css-extract-plugin
export var marginNegative = "_5l-5 _5l-3 _5l-1";
export var marginPositive = "_5l-4 _5l-3 _5l-1";
export var modalContent = "_5l-6";
export var samplesTable = "_5l-8";
export var samplesTableContainer = "_5l-7";
export var statBox = "_5l-a";
export var tableCell = "_5l-1";
export var tableCellCenter = "_5l-2 _5l-1";
export var tableCellRight = "_5l-3 _5l-1";
export var tableHeader = "_5l-0";
export var trackingNumber = "_5l-9";